var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1800,
    zoomAndPan: "magnify",
    viewBox: "0 0 1350 1349.999938",
    height: 1800,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e29fdce758"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 406.363281 134.996094 L 943.628906 134.996094 L 943.628906 1215 L 406.363281 1215 Z M 406.363281 134.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0b7560d51e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 943.628906 674.996094 L 406.363281 1214.996094 L 406.363281 134.996094 Z M 943.628906 674.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78c96e561d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.363281 0.996094 L 537.628906 0.996094 L 537.628906 1081 L 0.363281 1081 Z M 0.363281 0.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "51a521ab5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 537.628906 540.996094 L 0.363281 1080.996094 L 0.363281 0.996094 Z M 537.628906 540.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "078ec318c4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 538,
    y: 0,
    height: 1081
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e29fdce758)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b7560d51e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 406, 134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#078ec318c4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78c96e561d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#51a521ab5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 537.628906 0.996094 L 537.628906 1081.824219 L 0.363281 1081.824219 L 0.363281 0.996094 Z M 537.628906 0.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a90a55641932d740eeb9210302b13517.svg";
export { ForwardRef as ReactComponent };